import Modal from '@components/v2/ui/Modal/Modal';
import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';

interface CatalogBatchInactivateModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const CatalogBatchInactivateModal = ({
  open,
  onClose,
  onConfirm,
}: CatalogBatchInactivateModalProps) => {
  const { translate } = useTranslation();

  return (
    <Modal
      isOpen={open}
      size="standard"
      header={{ title: translate(LangEnum.CATALOGS_BULK_DEACTIVATE_MODAL_TITLE) }}
      onClose={onClose}
      footer={{
        primaryAction: {
          label: translate(LangEnum.CATALOGS_BULK_MENU_DEACTIVATE),
          onClick: onConfirm,
        },
        secondaryAction: {
          label: translate(LangEnum.GLOBAL_CANCEL_LABEL),
          onClick: onClose,
        },
      }}
    >
      <Typography variant="body1" color="text.secondary">
        {translate(LangEnum.CATALOGS_BULK_DEACTIVATE_MODAL_DESCRIPTION)}
      </Typography>
    </Modal>
  );
};

export default CatalogBatchInactivateModal;
